export const getFormattedSiteAddress = (siteAddress) => {
    if (!siteAddress)
        return undefined;
    const addressComponents = [];
    const { line1, line2, city } = siteAddress;
    if (line1)
        addressComponents.push(line1);
    if (line2)
        addressComponents.push(line2);
    if (city)
        addressComponents.push(city);
    return addressComponents.length > 0 ? addressComponents.join(', ') : undefined;
};
